/**
 * Render markdownu (LLM reporty, poznatky z wiki).
 *
 * Obsah je nedůvěryhodný — reporty píše LLM, poznatky edituje kdokoli v HAW.
 * Proto jde všechno přes sanitizeMarkdown(); jiná cesta do DOM neexistuje
 * (hlídá eslint pravidlo v .eslintrc.cjs).
 */
import { useMemo } from 'react';
import { sanitizeMarkdown } from '@/lib/sanitize';

export interface MarkdownViewProps {
  markdown: string | null | undefined;
  /** označit obsah jako AI generovaný (provenance je povinná, 00 §3) */
  aiGenerated?: boolean;
  model?: string | null;
  className?: string;
}

export function MarkdownView({ markdown, aiGenerated, model, className }: MarkdownViewProps) {
  // Jméno `sanitizedHtml` je konvence vynucená eslintem — viz .eslintrc.cjs.
  const sanitizedHtml = useMemo(() => sanitizeMarkdown(markdown), [markdown]);

  if (!markdown) {
    return <p className="markdown-view__empty">Zatím tu není žádný text.</p>;
  }

  return (
    <div className={`markdown-view${className ? ` ${className}` : ''}`}>
      {aiGenerated ? (
        <div className="ai-provenance" role="note">
          <span className="ai-provenance__badge">AI</span>
          <span>
            Vygenerováno jazykovým modelem{model ? ` (${model})` : ''}. Čísla pocházejí
            z vyhodnocovacího JSONu, ne z modelu — ale závěry si ověř.
          </span>
        </div>
      ) : null}
      {/* Obsah prošel sanitizeMarkdown() — viz lib/sanitize.ts */}
      <div className="markdown-view__body" dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />
    </div>
  );
}
